import { ChangeDetectionStrategy, Component, Injector, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ChecklistService } from '../../checklist/checklist.service';
import { ISystemNotificationsCheckpointAnswer } from '@fi-shared/checklist/checklist';
import { takeUntil } from 'rxjs/operators';
import { OperationOverlayLargeNg4Service } from '@fi-app/utilities/operation-overlay-large/operation-overlay-large.service';
import { FiChecklistCheckpointViewDialogComponent } from '@fi-app/checklist/checkpoint-view-dialog/checkpoint-view-dialog.component';
import { FiInfiniteScrollDataSource } from '@fi-shared/fi-items-list/fi-infinite-scroll-data-source';
import { ObjectTypes } from '@fi-shared/types';
import { FiNewsFeedSharedService } from '@fi-shared/fi-news-feed-shared/fi-news-feed-shared.service';
import { IObjectDto } from '@fi-shared/models/models';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { AppTextService } from '@fi-shared/app-text';
import { BusinessUnitService } from '@fi-app/business-unit/business-unit.service';
import { FiItemsListType } from '@fi-shared/fi-items-list/fi-items-list-type';

@Component({
    selector: 'fi-checkpoint-answer',
    templateUrl: './checkpoint-answer.component.html',
    styleUrls: ['./checkpoint-answer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checkpoint-answer' },
    standalone: false,
})
export class SystemNotificationsCheckpointAnswerComponent
    extends FiInfiniteScrollDataSource<ISystemNotificationsCheckpointAnswer>
    implements OnInit, OnDestroy
{
    defaultSortColumnName: string = '';
    itemsListType = FiItemsListType.SystemNotificationsCheckpointAnswers;
    objectType = ObjectTypes.CheckPointAnswer;

    constructor(
        private checkListService: ChecklistService,
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
        injector: Injector,
        private newsFeedSharedService: FiNewsFeedSharedService,
        private operationOverlayLargeNg4Service: OperationOverlayLargeNg4Service,
        private businessUnitService: BusinessUnitService,
    ) {
        super(injector, {});
    }

    ngOnInit() {
        this.checkListService.checkPointAnswerNotifications$
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe((checkpointAnswers: ISystemNotificationsCheckpointAnswer[]) => {
                this.reloadData();
            });
    }

    openChecklistDeviationOverlay($event, item: ISystemNotificationsCheckpointAnswer) {
        $event.preventDefault();
        $event.stopPropagation();
        this.operationOverlayLargeNg4Service.openOperationOverlayLargeDialog(
            FiChecklistCheckpointViewDialogComponent,
            {
                checkpointAnswer: item,
            },
            {
                showInsert: false,
                Title: item.CheckListName,
            },
        );
    }

    getListData() {
        return Promise.resolve(this.checkListService.checkPointAnswerNotifications);
    }

    confirmDelete() {
        this.fiDialogsService
            .confirm({
                messageText: this.getConfirmationMessageText(),
                headerText: this.appTextService.get('common.warning'),
                yesButtonText: this.appTextService.get('common.delete'),
            })
            .onYesButtonClick(() => this.removeNotifications());
    }

    private getConfirmationMessageText(): string {
        return this.appTextService.get(
            this.selectedItems.length > 1 ? 'checklist.deviation_notifications' : 'checklist.deviation_notification',
        );
    }

    private removeNotifications() {
        this.newsFeedSharedService.markNewsFeedsAsVisited(this.getItemsToRemove()).then(() => {
            this.checkListService.onDeleteCheckPointAnswerNotifications(this.selectedItems().map((item) => item.Id));
        });
    }

    private getItemsToRemove(): IObjectDto[] {
        const selectedItems = this.selectedItems();
        return selectedItems.map((item) => {
            return {
                ObjectId: item.Id,
                ObjectType: ObjectTypes.CheckPointAnswerNotification,
            };
        });
    }

    showBusinessUnitDialog(businessUnitId: number) {
        this.businessUnitService.openBusinessUnitViewDialog(businessUnitId);
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }
}
